import type { MonthlyRevenue, CategoryData, PlatformPerformanceParams } from '../types/analytics.types'

export const mockRevenueData: MonthlyRevenue[] = [
    { month: 'Jan', revenue: 45000 },
    { month: 'Feb', revenue: 52000 },
    { month: 'Mar', revenue: 61000 },
    { month: 'Apr', revenue: 58000 },
    { month: 'May', revenue: 67000 },
    { month: 'Jun', revenue: 75000 },
]

export const mockCategoryData: CategoryData[] = [
    { category: 'Cement', orders: 45, value: 157500 },
    { category: 'Steel', orders: 38, value: 133000 },
    { category: 'Bricks', orders: 52, value: 52000 },
    { category: 'Sand', orders: 28, value: 28000 },
    { category: 'Aggregates', orders: 35, value: 35000 },
]

export const mockPerformance: PlatformPerformanceParams = {
    averageOrderValue: 3788,
    conversionRate: 23.5,
    customerSatisfaction: 4.6,
}
